export enum HeaderRequestEnum {
    NoAuthenticate = 1,
    NoShowLoading,
    Pagination,
    /** Resumen clientes (varias peticiones en cadena): header para el API + sin barra global. */
    NoShowSpinner,
}
